import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import ZpButton from 'components/zpButton';

import css from './bottomClusterNavigation.module.css';

const BottomClusterNavigation = ({ subheaderItems, hideNext = false, jobTitle = '', containerClassNames = '' }) => {
  const [prevPage, setPrevPage] = useState(0);
  const [nextPage, setNextPage] = useState(0);

  const currentPageIndex = subheaderItems
    ? subheaderItems.findIndex((item) => item.isCurrentPage)
    : null;

  useEffect(() => {
    switch (currentPageIndex) {
      case 0:
        setPrevPage(subheaderItems.length - 1);
        setNextPage(currentPageIndex + 1);
        break;
      case subheaderItems.length - 1:
        setPrevPage(currentPageIndex - 1);
        setNextPage(0);
        break;
      default:
        setPrevPage(currentPageIndex - 1);
        setNextPage(currentPageIndex + 1);
        break;
    }
  }, [currentPageIndex, subheaderItems]);

  const navigateToPage = (page) => {
    window.location.href = subheaderItems[page].link;
  };

  return (
    <div
      className={cn(
        'container z-mt-48 px-0 d-flex justify-content-between align-items-center',
        css['bottom-cluster-navigation'],
        containerClassNames,
      )}
    >
      {currentPageIndex !== -1 && (
        <>
          <ZpButton
            overflowHidden
            theme="secondary"
            size="big"
            icon={<i className={css['submenuArrowIcon']} aria-hidden="true" />}
            onClick={() => navigateToPage(prevPage)}
            className={cn('d-sm-block d-none', css['nav-button'], css['prev'])}
          >
            <span className={css['button-direction']}>Previous:</span>
            <span className={css['page-name']}>{`${jobTitle ? `${jobTitle} ` : ''}${
              subheaderItems[prevPage].title
            }`}</span>
          </ZpButton>
          {subheaderItems[nextPage] && !hideNext && (
            <ZpButton
              overflowHidden
              theme="secondary"
              size="big"
              isLeftIcon={false}
              icon={<i className={css['submenuArrowIcon']} aria-hidden="true" />}
              onClick={() => navigateToPage(nextPage)}
              className={cn(css['nav-button'], css['next'])}
            >
              <span className={css['button-direction']}>Next: </span>
              <span className={css['page-name']}>{`${jobTitle ? `${jobTitle} ` : ''}${
                subheaderItems[nextPage].title
              }`}</span>
            </ZpButton>
          )}
        </>
      )}
    </div>
  );
};

export default React.memo(BottomClusterNavigation);
